import React from 'react';
import './style.sass';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import parse from 'html-react-parser';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonSmallText from '../../../common-components/common-small-text';

const devRecList = [
    {
        img: '/images/pic/dev-rec/results-1.png',
        text:
            'Создали два больших новых раздела на&nbsp;основном сайте, промо-лендинги, новый функционал ' +
            'на&nbsp;внутреннем портале. Упростили сбор заявок на&nbsp;конкурс &laquo;Экспортер года&raquo;.',
    },
    {
        img: '/images/pic/dev-rec/results-2.png',
        text:
            'На&nbsp;внутреннем портале поддерживается и&nbsp;дорабатывается множество интеграций: Active Directory, ' +
            '1С&nbsp;Бухгалтерия, почтовые интеграции, смс-сервисы (для рассылок, авторизации) и&nbsp;др.',
    },
];

const Results = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper className="dev-rec-results" bigPaddings={true}>
                <CommonTitle className="dev-rec-results__title">Результаты</CommonTitle>
                <div className="dev-rec-results__wrapper">
                    <div className="dev-rec-results__grid">
                        {devRecList.map((item, index) => {
                            return (
                                <div className="dev-rec-results__item" key={index}>
                                    <div className="dev-rec-results__item-img">
                                        <img src={item.img} alt="" loading="lazy" />
                                    </div>
                                    <CommonSmallText className="dev-rec-results__item-content">
                                        {parse(item.text)}
                                    </CommonSmallText>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default Results;
